'use client';

import { useEffect, useState } from 'react';
import { isPollingAllowed, subscribePollingGate } from '../lib/pollingManager';

export function usePollingGate() {
  const [allowPolling, setAllowPolling] = useState(isPollingAllowed);

  useEffect(() => subscribePollingGate(({ documentVisible, userActive }) => {
    setAllowPolling(documentVisible && userActive);
  }), []);

  return { allowPolling };
}
